import { abi } from './abi';
import { SERVICE_PROVIDER_FACTORY_CONTRACT_ADDRESS } from './constants';
export class ServiceProviderFactory {
    constructor(client, { address } = {}) {
        this.getTotalServiceTypeProviders = ({ serviceType }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getTotalServiceTypeProviders',
            args: [serviceType]
        });
        this.getServiceEndpointInfo = ({ serviceType, index }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getServiceEndpointInfo',
            args: [serviceType, index]
        });
        this.client = client;
        this.address = address ?? SERVICE_PROVIDER_FACTORY_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=serviceProviderFactory.js.map